'use strict';
import EditFormView from './EditFormView';
import EditFormViewLocals from './EditFormViewLocals';

export default class EditFormTabService {
	constructor(sidePanelService, i18n) {
		this.i18n = i18n;
		this.sidePanelService = sidePanelService;
	}

	/**
	 * @ngdoc method
	 * @name mx.SolutionBuilderAgent.EditFormTabService#open
	 *
	 * @description
	 * Open a `Edit Form tab` dialog with specific template.
	 *
	 * @param {object} options - options for selection grid, convert to MultiSelectionTabOptions
	 * @param {DetailsView} parentView - view from which MultiSelectionTab was opened
	 *
	 * @returns {Promise} - promise, which will be resolved with selected item that user selected on this Dialog.
	 *
	 */
	open(options, parentView) {
		options.cancelLabel = this.i18n.get('solutionBuilderAgent.common.cancel_btn');
		options.saveLabel = this.i18n.get('solutionBuilderAgent.common.ok_btn');

		var locals = new EditFormViewLocals(options);
		var view = new EditFormView(this.i18n, {
			isAddingNew: options.isAddingNew,
			displayName: locals.title,
			locals: locals,
		});

		return this.sidePanelService.addView(view, parentView, true);
	}
}
EditFormTabService.$inject = ['mx.shell.SidePanelService', 'mx.internationalization'];
